import { useEffect, useState } from 'react';
import { BrowserRouter, Link, Route, Routes, useLocation } from 'react-router-dom';
import Lenis from 'lenis';
import { MotionConfig } from 'framer-motion';
import '@fontsource/plus-jakarta-sans/latin-400.css';
import '@fontsource/plus-jakarta-sans/latin-500.css';
import '@fontsource/plus-jakarta-sans/latin-600.css';
import '@fontsource/plus-jakarta-sans/latin-700.css';
import '@fontsource/plus-jakarta-sans/latin-800.css';
import 'lenis/dist/lenis.css';
import './App.css';
import { Toaster } from './components/ui/sonner';
import { Header } from './components/site/Header';
import { Marquee } from './components/site/Hero';
import { HeroExperience } from './components/site/HeroExperience';
import { Services } from './components/site/Services';
import { About, Area, Process } from './components/site/About';
import { Benefits } from './components/site/Benefits';
import { Contact } from './components/site/Contact';
import { Footer } from './components/site/Footer';
import { BackgroundMusic } from './components/site/BackgroundMusic';
import Legal from './pages/Legal';

function Home() {
  const [selected, setSelected] = useState([]);
  const [activeGroup, setActiveGroup] = useState('reinigung');
  const toggleService = service => setSelected(previous => previous.includes(service) ? previous.filter(s => s !== service) : [...previous, service]);
  return <main data-testid="homepage"><HeroExperience /><Marquee /><Services selected={selected} toggleService={toggleService} onChooseGroup={setActiveGroup} /><About /><Benefits /><Process /><Area /><Contact selected={selected} toggleService={toggleService} activeGroup={activeGroup} setActiveGroup={setActiveGroup} /></main>;
}

function Site() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true, anchors: { offset: -105 }, autoRaf: true });
    return () => lenis.destroy();
  }, []);
  useEffect(() => {
    document.title = pathname === '/impressum' ? 'Impressum | betaris Glanzwerk' : pathname === '/datenschutz' ? 'Datenschutz | betaris Glanzwerk' : 'betaris Glanzwerk | Reinigung & Hausmeisterservice in Heilbronn';
    if (!hash) window.scrollTo({ top: 0, behavior: 'instant' });
    else { const timer = window.setTimeout(() => document.getElementById(hash.slice(1))?.scrollIntoView(), 120); return () => window.clearTimeout(timer); }
  }, [pathname, hash]);
  return <MotionConfig reducedMotion="user"><div id="top"><a className="skip-link" href="#main-content" data-testid="skip-to-content">Zum Inhalt</a>{pathname !== '/' && <Header />}<div id="main-content"><Routes><Route path="/" element={<Home />} /><Route path="/impressum" element={<Legal type="impressum" />} /><Route path="/datenschutz" element={<Legal type="datenschutz" />} /><Route path="*" element={<main className="not-found container" data-testid="not-found-page"><span>404</span><h1>Hier gibt es nichts zu reinigen.</h1><p>Diese Seite wurde nicht gefunden.</p><Link to="/" className="text-link" data-testid="not-found-home-link">Zur Startseite →</Link></main>} /></Routes></div><Footer /><BackgroundMusic /><Toaster position="bottom-right" theme="light" richColors /></div></MotionConfig>;
}

export default function App() { return <BrowserRouter><Site /></BrowserRouter>; }